import React, {useEffect, useState} from 'react';
import Color from "color";

import TemplateCollectivHeader from "./templates/BASE/TemplateCollectivHeader";
import Template2Mentions from "./templates/RU/Template2Mentions";
import {Spinner} from "react-bootstrap";
import TemplateCUBEquipement from "./templates/CU/TemplateCUBEquipement";
import TemplateCUBavis from "./templates/CU/TemplateCUBavis";
import TemplateCUBSignature from "./templates/CU/TemplateCUBSignature";
import TemplateCUBUrbaDemo from "./templates/CU/TemplateCUBUrbaDemo";
import TemplateCUAUrba2Demo from "./templates/CU/TemplateCUAUrba2Demo";
import Template1BPreemptionDemo from "./templates/BASE/Template1BPreemptionDemo";
import TemplateCUTaxeDemo from "./templates/CU/TemplateCUTaxeDemo";
import TemplateCUBParticipationDemo from "./templates/CU/TemplateCUBParticipationDemo";
import TemplateCUAUrba3Demo from "./templates/CU/TemplateCUAUrba3Demo";


const CUB2Form = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [displayForm, setDisplayForm] = useState("cub")
    const [primaryCol, setPrimaryCol] = useState(Color("#FFFF"))



    return (
        (isLoading)
            ?<div className="text-center my-2"><Spinner animation="border" size={'sm'}/></div>
            :<>
                <TemplateCollectivHeader logob64={props.logob64} stampb64={props.stampb64} doctype={"CUb"}/>
                <h2 style={{"textAlign": "center", "fontWeight":"400"}}><strong>CERTIFICAT D'URBANISME OPÉRATIONNEL</strong></h2>
                    <TemplateCUBUrbaDemo   formtype={"cub"}  primColor={primaryCol}   demInfo={props.demInfo}   />
                    {/*
                    <Template1BSynthese formtype={displayForm} primColor={primaryCol}  />
                    <div className="page-break"/>
                    */}
                    <TemplateCUAUrba2Demo  formtype={displayForm} primColor={primaryCol} />
                    <TemplateCUAUrba3Demo  formtype={displayForm} primColor={primaryCol} />

                     {/*
                    <Template1BRisque formtype={displayForm} primColor={primaryCol} />
                    <Template1BServitude formtype={displayForm} primColor={primaryCol} />
                    <Template1BPrescription formtype={displayForm} primColor={primaryCol} />
                    */}
                    <Template1BPreemptionDemo formtype={displayForm} primColor={primaryCol} />
                    <TemplateCUTaxeDemo formtype={displayForm} primColor={primaryCol} />
                    <TemplateCUBParticipationDemo primColor={primaryCol} />
                    <TemplateCUBEquipement primColor={primaryCol} />
                    <TemplateCUBavis primColor={primaryCol} />
                    <TemplateCUBSignature primColor={primaryCol} />
                    <Template2Mentions primColor={primaryCol} />

            </>
    );
}

export default CUB2Form;
